import type { Auth0ContextInterface } from '@auth0/auth0-react';
import { baseApiRequest } from "../baseApiRequest"

const origin = process.env.REACT_APP_API_ORIGIN ?? ''

export async function auth0QueryFunction<TResponse>(path: string, getAccessTokenSilently: Auth0ContextInterface['getAccessTokenSilently'], loginWithRedirect: Auth0ContextInterface['loginWithRedirect'], audience: string, scope: string) {
  const url = `${origin}/api/${path}`

  // Try getting the token silently
  let accessToken = ''
  try {
    accessToken = await getAccessTokenSilently({ audience, scope })
  } catch (e) {
    console.warn('getAccessTokenSilently() useapiquery FAILED, redirecting to login…', e)
    await loginWithRedirect({
      appState: { returnTo: window.location.pathname + window.location.search }
    })
    throw new Error('Authentication required')
  }

  return baseApiRequest<TResponse>({
    url,
    init: {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    },
    trackingEvent: 'auth0QueryFunction',
  })
}
